import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
export var ScrollToTop = function () {
    var pathname = useLocation().pathname;
    useLayoutEffect(function () {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};
